export const redirectOrPageReload = (url?: string | null): void => {
    if (url) {
        window.location.assign(url);
        return;
    }

    window.location.reload();
};
